export const FeatureSet =
{
    ShowGrid : false,
    MeasureTool : false
};
